import { createMuiTheme } from '@material-ui/core/styles';

import styles from '../styles/main.scss';

export const styledTheme = {
  overrides: {
    MuiButton: {
      root: {
        color: '#999a9a',
      },
    },
    MuiLinearProgress: {
      bar1Determinate: {
        backgroundColor: '#37474f',
      },
      colorPrimary: {
        backgroundColor: '#999a9a',
      },
    },
  },
  palette: {
    primary: {
      main: '#ffca28',
      dark: '#c79a00',
    },
    secondary: {
      main: '#37474f',
      dark: '#102027',
    },
    gray: {
      main: '#424242',
      light: '#e1e2e1',
    },
    blue: {
      main: '#62727b',
      light: '#999a9a',
    },
  },
  typography: {
    headerFontFamily: 'Helvetica, Arial, sans-serif',
    bodyFontFamily: 'Times New Roman, serif',
  },
  zIndex: {
    header: 1500,
  },
  action: {
    hover: '#ffca28',
  },
};

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      light: '#757ce8',
      main: styles.primary_main,
      dark: '#002884',
      contrastText: styles.contrast_text_black,
    },
    secondary: {
      light: styles.secondary_main,
      main: styles.secondary_dark,
      dark: '#ba000d',
      contrastText: styles.contrast_text_white,
    },
  },
});

export default theme;
